import { Drawer, FloatButton } from "antd";
import {
    AppstoreOutlined,
    BgColorsOutlined,
    InfoCircleOutlined,
    LogoutOutlined,
    SearchOutlined
} from "@ant-design/icons";
import React, { useState } from "react";
import { SingleLayerSettingsLayer } from "./SingleLayerSettingsLayer";
import { SingleLayerSettingsColor } from "./SingleLayerSettingsColor";
import { SingleLayerSettingsStory } from "./SingleLayerSettingsStory";
import { SingleLayerSettingsHelp } from "./SingleLayerSettingsHelp";
import KeycloakService from "../core/keycloakService";
import { useParams } from "react-router-dom";
import { SingleLayerSettingsH3 } from "../H3/SingleLayerSettingsH3";
import { HexagonIcon } from "../core/customIcons";
import { SingleLayerSettingsSearch } from "./SingleLayerSettingsSearch";

export function SingleLayerSettings({
    data,
    mapTheme,
    setMapTheme,
    colorMaps,
    colorMapName,
    setColorMapName,
    colorMapOpacity,
    setColorMapOpacity,
    isH3,
    setData,
    zoom,
    setZoom,
    color,
    setColor,
    height,
    setHeight,
    viewState,
    setViewState
}) {
    let { id } = useParams();
    const [openDrawer, setOpenDrawer] = useState(false);
    const [title, setTitle] = useState('');
    const [section, setSection] = useState(''); // ['layer', 'story', 'color']


    const toggleDrawer = (sectionNew) => {

        if (section === sectionNew && openDrawer === true) {
            setOpenDrawer(!openDrawer);
            setSection('')
        } else {
            if (openDrawer === false) {
                setOpenDrawer(!openDrawer);
            }

            setSection(sectionNew)
            switch (sectionNew) {
                case 'layer':
                    setTitle('Basemap')
                    break;
                case 'story':
                    setTitle('Story telling')
                    break;
                case 'color':
                    setTitle('Color map')
                    break;
                case 'search':
                    setTitle('Search')
                    break;
                case 'h3':
                    setTitle('Risk analyzer')
                    break;
                default:
                    setTitle('')
            }
        }
    };
    const onDrawerClose = () => {
        setOpenDrawer(false);
        setSection('')
    };

    return (
        <>
            <FloatButton.Group
                shape="circle"
                style={{
                    top: 40,
                    right: openDrawer ? 540 : 40
                }}
            >
                <FloatButton
                    onClick={() => KeycloakService.logout()}
                    tooltip={<div>Logout</div>}
                    icon={<LogoutOutlined />}
                />
                <FloatButton
                    onClick={() => toggleDrawer('layer')}
                    tooltip={<div>Basemap</div>}
                    type={section === 'layer' ? 'primary' : 'default'}
                    icon={<AppstoreOutlined />}
                />
                <FloatButton
                    onClick={() => toggleDrawer('story')}
                    tooltip={<div>Story telling</div>}
                    type={section === 'story' ? 'primary' : 'default'}
                    icon={<InfoCircleOutlined />} />
                <FloatButton
                    onClick={() => toggleDrawer('color')}
                    type={section === 'color' ? 'primary' : 'default'}
                    tooltip={<div>Color map</div>}
                    icon={<BgColorsOutlined />} />
                <FloatButton
                    onClick={() => toggleDrawer('search')}
                    type={section === 'search' ? 'primary' : 'default'}
                    tooltip={<div>Search</div>}
                    icon={<SearchOutlined />} />
                {isH3 && <FloatButton
                    onClick={() => toggleDrawer('h3')}
                    type={section === 'h3' ? 'primary' : 'default'}
                    tooltip={<div>Risk analyzer settings</div>}
                    icon={<HexagonIcon isDraweOpen={openDrawer} />} />
                }
            </FloatButton.Group>

            {data && <SingleLayerSettingsHelp
                data={data}
                colorMapName={colorMapName}
                openDrawer={openDrawer}
                isH3={isH3}
            />}

            <Drawer title={title}
                width={500}
                placement="right"
                onClose={onDrawerClose}
                open={openDrawer}
                closeIcon={true}
                mask={false}
                maskClosable={false}>

                {section === 'layer' && <SingleLayerSettingsLayer
                    mapTheme={mapTheme}
                    setMapTheme={setMapTheme}
                />}
                {section === 'story' && <SingleLayerSettingsStory id={data.id} />}
                {section === 'h3' &&
                    <SingleLayerSettingsH3 data={data} setData={setData} zoom={zoom} setZoom={setZoom} height={height}
                        setHeight={setHeight} color={color} setColor={setColor} />}
                {section === 'color' && <SingleLayerSettingsColor
                    colorMaps={colorMaps}
                    colorMapName={colorMapName}
                    setColorMapName={setColorMapName}
                    colorMapOpacity={colorMapOpacity}
                    setColorMapOpacity={setColorMapOpacity}
                    data={data}
                />}
                {section === 'search' && <SingleLayerSettingsSearch
                    viewState={viewState}
                    setViewState={setViewState}
                    data={data}
                />}
            </Drawer>
        </>
    )
}